const get = require('lodash/get')

module.exports = getProductsForFollowUp
function getProductsForFollowUp (shipment, snapshot, translatedCounts) {
  // If an explicit snapshot is provided, use it. Otherwise:
  // 1) Try the ':status:new:' snapshot from history
  // 2) Else fall back to the earliest snapshot from history
  const historyEntries = shipment && shipment.history ? Object.entries(shipment.history) : []
  const newSnapshotFromHistory = historyEntries.find(([key]) => key.includes(':status:new:'))
  const earliestSnapshotFromHistory = historyEntries.length ? historyEntries[0] : null

  const resolvedSnapshot = snapshot ||
    (newSnapshotFromHistory ? newSnapshotFromHistory[1] : (earliestSnapshotFromHistory ? earliestSnapshotFromHistory[1] : null))

  // If we still cannot resolve a snapshot, use an empty counts map to prevent runtime errors
  const changes = Object.entries((resolvedSnapshot && resolvedSnapshot.counts) || {})
    .map(([productId, data]) => {
      const receivedQuantity = translatedCounts ? get(translatedCounts, `${productId}.quantity`, 0) : get(shipment, `counts.${productId}.quantity`, 0)
      const diff = receivedQuantity - data.quantity
      return ({
        ...data,
        productId,
        diff,
        receivedQuantity
      })
    })
  return changes.filter(({ diff }) => diff < 0)
}
